export default {
    URL_API: "https://apisgt.rncloud.com.br/api", 
    URL_API_OLD: "https://apisgt.devtrimap.com.br/api",
    URL_REPORTS: "https://apirelatorios.rncloud.com.br/api",
    URL_REPORTS_OLD: "https://apirelatorios.devtrimap.com.br/api",
    mfeBlazorEnabled: false
}

